import React, { Component } from 'react'
import '../App.css'
import resume from "../my resume.pdf"
// import NavContent from './NavContent';

class UpperBody extends Component {
    
  
    render() { 

        const typeWriter = function(txtDOM, words, wait = 2000){
            this.txtDOM = txtDOM;
            this.words = words;
            this.txt = "";
            this.wordIdx = 0;
            this.wait = parseInt(wait, 10);
            this.type();
            this.isDeleting = false;
        }
        
        typeWriter.prototype.type = function() {

            const currentIndex = this.wordIdx % this.words.length

            //get words
            const fullTxt = this.words[currentIndex];

            //check if deleting
            if(this.isDeleting) {
                //remove char
                this.txt = fullTxt.substring(0, this.txt.length - 1)

            } else {
                //add char

                this.txt = fullTxt.substring(0, this.txt.length + 1)
            }

            //insert text to dom 
            this.txtDOM.innerHTML = `<span class="txt">${this.txt}</span>`;

            //type duration
            let createSpeed = 100;

            if (this.isDeleting) {
                createSpeed /= 2
            }

            //if word is complete
            if(!this.isDeleting && this.txt === fullTxt) {
                //pause at end
                createSpeed = this.wait;

                //start deleting
                this.isDeleting = true
            } else if (this.isDeleting && this.txt === '') {
                //stop delete
                this.isDeleting = false;
                //next word movement
                this.wordIdx++;
                //pause before start typing
                createSpeed = 100
            }

            setTimeout(() => {
                this.type()
            }, createSpeed);
        }

        
        function init() {
            const txtDOM = document.querySelector('.displayText');
            const words = JSON.parse(txtDOM.getAttribute("data-words"));
            const wait = txtDOM.getAttribute("data-wait");
            
            new typeWriter(txtDOM,words, wait);
        }
        
        //start on load
        document.addEventListener('DOMContentLoaded', init);

        return ( 
            <div className="main" id="home">
                
                <div className="main_text">
                    <div className="inner_main">
                        <h3 className='headText'>Hello, I'm Adedotun</h3>
                        <h1>
                            I'm 
                            <span className="displayText"
                                data-wait="1000"
                                data-words='[" a Software ", " a Front-End "]'
                            ></span>
                              Dev
                        </h1>
                    </div>
                    <p>I believe so much in the web and the power therein, I really get joy from learning new things about web technologies and things I can do with the web.
                    </p><br/>

                    <a className="btn" href={resume} download>My Resume</a>
                </div>
                
            </div>
        );
    }
}
 
export default UpperBody;